module.exports = {
	"$schema": "http://iglucentral.com/schemas/com.snowplowanalytics.self-desc/schema/jsonschema/1-0-0#",
	"self": {
		"vendor": "com.codecombat",
		"name": "hints_next_clicked",
		"format": "jsonschema",
		"version": "1-0-0"
	},
	"type": "object",
	"properties": {
		"user": {"type": "string", "pattern": "^[a-z0-9]{24}$", "maxLength": 24, "minLength": 24},
		"hintCurrent": {"type": "integer"},
		"hintCount": {"type": "integer"},
		"levelSlug": {"type": "string", "maxLength": 128},
		"levelID": {"type": "string", "pattern": "^[a-z0-9]{24}$", "maxLength": 24, "minLength": 24}
		
	},
	"required": ["user", "levelSlug"],
	"additionalProperties": false
};